import { Component, Host, h, Element, Prop } from '@stencil/core';

// NOTE: Any icon which is added to the list below should be carefully constructed such that it:
// - Is a single color.
// - Does not have a `fill` attribute on either the <svg> or any child paths.
// - Has a `viewBox` attribute.
// - Does not have a `width` or `height` attribute.
//
// By doing this we ensure that the icon can be styled with CSS just by styling the width/height/color CSS properties.
//
const icons: { [key: string]: string } = {
  // The "x" or "close" icon.
  x: (
    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="5.60229"
        y="15.3372"
        width="13.7673"
        height="1.5"
        rx="0.75"
        transform="rotate(-45 5.60229 15.3372)"
      />
      <rect
        x="6.66284"
        y="5.60205"
        width="13.7673"
        height="1.5"
        rx="0.75"
        transform="rotate(45 6.66284 5.60205)"
      />
    </svg>
  ),

  equals: (
    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <rect x="4.11621" y="7" width="13.7673" height="1.5" rx="0.75" />
      <rect x="4.11621" y="13.5" width="13.7673" height="1.5" rx="0.75" />
    </svg>
  ),

  // The "table of contents" icon.
  toc: (
    <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.48486" y="3.94995" width="2.7" height="2.7" rx="1.35" />
      <rect x="7.18481" y="4.5" width="12.3301" height="1.6" rx="0.8" />
      <rect x="2.48486" y="9.6499" width="2.7" height="2.7" rx="1.35" />
      <rect x="7.18481" y="10.2" width="7.73682" height="1.6" rx="0.8" />
      <rect x="2.48486" y="15.3499" width="2.7" height="2.7" rx="1.35" />
      <rect x="7.18481" y="15.8999" width="9.31012" height="1.6" rx="0.8" />
    </svg>
  ),
};

export interface KbIcon extends HTMLKbIconElement {}

@Component({
  tag: 'kb-icon',
  styleUrl: 'kb-icon.css',
  shadow: true,
})
export class KbIcon {
  @Element() host!: HTMLKbIconElement;

  @Prop({ reflect: true }) name?: string;

  render() {
    return <Host>{this.name && icons[this.name]}</Host>;
  }
}
